import React from 'react'
import { CBadge, CCard, CCardBody, CFormSwitch, CLoadingButton, CSpinner } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilGift } from '@coreui/icons'

// The on/off panel at the top of the Bonus Cards page. While the add-on is off it is the
// whole page: one clear call to switch it on. Once on it shrinks to a status row.
const ActivateBonusCard = ({ active, loading, toggling, onToggle }) => {
  if (loading) {
    return (
      <CCard className="bc-panel">
        <CCardBody className="d-flex align-items-center gap-2 text-medium-emphasis py-4">
          <CSpinner size="sm" />
          <span>Loading bonus card settings...</span>
        </CCardBody>
      </CCard>
    )
  }

  if (!active) {
    return (
      <CCard className="bc-panel">
        <CCardBody className="ge-addon-off">
          <div className="ge-addon-off-icon">
            <CIcon icon={cilGift} size="xxl" />
          </div>
          <h2 className="ge-addon-off-title">Bonus cards are switched off</h2>
          <p className="ge-addon-off-text">
            Switch them on to set up a bonus card for each round: choose the players on it and award
            them bonus points on top of their round score. Members won&apos;t see bonus cards while
            they are off.
          </p>
          <CLoadingButton color="primary" loading={toggling} onClick={() => onToggle(true)}>
            <CIcon icon={cilGift} className="me-1" />
            Turn On Bonus Cards
          </CLoadingButton>
        </CCardBody>
      </CCard>
    )
  }

  return (
    <CCard className="bc-panel">
      <CCardBody className="ge-addon-status">
        <div className="ge-stat-icon ge-stat-icon--success">
          <CIcon icon={cilGift} size="lg" />
        </div>
        <div className="flex-grow-1">
          <div className="d-flex align-items-center gap-2">
            <h2 className="bc-panel-title">Bonus Cards</h2>
            <CBadge color="success" shape="rounded-pill">
              Active
            </CBadge>
          </div>
          <p className="bc-panel-note">
            Members can see bonus cards. Switching off hides them but keeps every card and bonus
            point you have set up.
          </p>
        </div>
        <CFormSwitch
          size="lg"
          id="is_bonus_card_activate"
          label="On"
          checked
          disabled={toggling}
          onChange={(e) => onToggle(e.target.checked)}
        />
      </CCardBody>
    </CCard>
  )
}

export default ActivateBonusCard
